import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import { formatDateSimple } from '@avanta/shared/utils/date';
import { EMPTY_VALUE } from 'constants/common';
import { PATIENT_RECORD_STATUS } from 'constants/patients';
import { type PatientRecordStatus, type PatientRecord } from 'types/patient';

export const getSickLeaveStartDate = (patientRecord?: PatientRecord): string => {
  if (!patientRecord?.values['fecha_baja']) return EMPTY_VALUE;
  return formatDateSimple(patientRecord.values['fecha_baja'] as unknown as string);
};

export const getRecordStatusLabel = (status: PatientRecordStatus): string => {
  if (status === PATIENT_RECORD_STATUS.OPEN) {
    return t('PatientRecords.status.open', { ns: LOCIZE_NS.INSURANCE });
  }
  return t('PatientRecords.status.closed', { ns: LOCIZE_NS.INSURANCE });
};

export const getRecordStatusClassName = (status: PatientRecordStatus): string => {
  if (status === PATIENT_RECORD_STATUS.OPEN) return 'text-teal-500';
  return 'text-red-800';
};
